<div class="navigation">
    @for (tab of tabs; track tab; let index = $index) {
        <div class="navigation-action" (click)="active = tab" [ngClass]="{'active': isActive(tab)}">
            <div class="navigation-action-label">
                <div class="navigation-action-label-title" id="tabs-action-{{index}}-label">
                    {{ tab.title | translate }}
                </div>
            </div>
        </div>
    }
</div>
<div class="main">
    <ng-content select="fui-tab"></ng-content>
</div>
